import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { Customer } from 'ish-core/models/customer/customer.model';

/**
 * CUSTOMIZATION: MVP 2.6.3 — warehouse customer detection for inventory visibility
 * and warehouse-held-only checkout without billing/payment.
 */
@Injectable({ providedIn: 'root' })
export class PresidioWarehouseCustomerService {
  private accountFacade = inject(AccountFacade);

  readonly isWarehouseCustomer$: Observable<boolean> = this.accountFacade.customer$.pipe(
    map(customer => isPresidioWarehouseCustomer(customer)),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );
}

/** True when customer has warehouse segment or `warehouseCustomer` attribute. */
export function isPresidioWarehouseCustomer(customer: Customer | null | undefined): boolean {
  if (!customer) {
    return false;
  }
  if (
    customer.customerSegments?.some(
      s => s.id?.toLowerCase() === 'warehouse' || s.name?.toLowerCase() === 'warehouse'
    )
  ) {
    return true;
  }
  const attr = customer.attributes?.find(a => a.name === 'warehouseCustomer');
  const value = (attr?.value || '').trim().toLowerCase();
  return value === 'true' || value === '1' || value === 'yes';
}
